import { render } from "./RefikaAdmin.vue?vue&type=template&id=3ab12cad&scoped=true"
import script from "./RefikaAdmin.vue?vue&type=script&lang=js"
export * from "./RefikaAdmin.vue?vue&type=script&lang=js"

import "./RefikaAdmin.vue?vue&type=style&index=0&id=3ab12cad&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab12cad"]])

export default __exports__